import httpClient from './http-client';
import mockTcpParticipationService from './tpd-participation.service.mock';

let tpdParticipationService;

if (process.env.NODE_ENV === 'development') {
  tpdParticipationService = mockTcpParticipationService;
} else {
  tpdParticipationService = {
    getList(params) {
      return httpClient.get('/tpd/tpdr', {params});
    },
    getProcessList(params) {
      return httpClient.get('/tpd/tpdris', {params});
    }
  }
}

export default tpdParticipationService;
